import { html, LitElement } from "lit-element";
import { storeInstance } from "../store";
import seo from "../utils/seo";

class KbNotFound extends LitElement {
  connectedCallback() {
    super.connectedCallback();
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    seo(
      "404 - Page Not Found",
      "Sorry, we couldn't find that page. Please use the search field or home button to find the page you're looking for."
    );
  }

  stateChange(state) {
    this.state = state;
  }

  disconnectedCallback() {
    storeInstance.dispatch("setState", {
      property: "show_not_found",
      value: false,
    });
    super.disconnectedCallback();
  }

  render() {
    return html` <style>
        .not-found-content {
          width: 100%;
          position: absolute;
          display: flex;
          flex-direction: column;
          align-items: center;
          top: 40%;
          justify-content: center;
        }
      </style>
      <div class="not-found-content">
        <h1 id="error-title">404 - Page Not Found</h1>
        <p id="not-found-message">
          Sorry, we couldn't find that page. Please use the search field or home
          button to find the page you're looking for.
        </p>
      </div>`;
  }
}

customElements.define("kb-not-found", KbNotFound);
